import { Configuration, UserApi } from '@oolio-group/sso-sdk/accounts';
import {
  UserInfo,
  UserInfoClient,
} from '@/libs/device-auth/services/authService';

export class SsoUserInfoClient implements UserInfoClient {
  constructor(private readonly basePath: string) {}

  async getUser(
    userId: string,
    accessToken: string,
    signal?: AbortSignal,
  ): Promise<UserInfo> {
    const api = new UserApi(
      new Configuration({
        basePath: this.basePath,
        accessToken,
      }),
    );

    const user = await api.getUser({ userId }, { signal });

    return {
      id: user.id ?? userId,
      email: user.email ?? '',
      firstName: user.firstName,
      lastName: user.lastName,
    };
  }
}
